import { schema } from "normalizr";
export const agent = new schema.Entity("agent");
export const agentSchema = new schema.Entity("agents", {
  agents: [agent]
}, {
  idAttribute: "username"
});